// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.fees.multifamily.RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { DeleteMultifamilyListingFeesRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete_Args {
  postData: DeleteMultifamilyListingFeesRequestDto;
}

export type RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete_Args
>;

/**
 * Deletes a group of fees for a multi family listing
 */
export const useRentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete(args.postData, httpClient),
  });
};
